import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { ImageList, Text } from '~/common/components/defaultUIComponents';
import { useCreateEditJobForm } from '../CreateEditJob/utils';
import { Job } from '~/common/entities/Project/ProjectTypes';
import { ID } from '~/common/api/common/apiCommons';

type Props = {
  job: Job;
  isOpen: boolean;
  onClose: () => void;
  projectID?: ID;
};

export const JobListPhotoModal = ({
  job,
  isOpen,
  onClose,
  projectID,
}: Props) => {
  const { setImages, initialImages, rotatePicture } = useCreateEditJobForm(
    job.id,
    projectID,
    isOpen,
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'md'}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text>jobTile.editPictures.heading</Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isOpen && (
            <ImageList
              initialImages={initialImages}
              onChange={setImages}
              onRotate={rotatePicture}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
